import { BETA_LABEL, BETA_PILL_BG_HEX, BETA_PILL_FG_HEX } from '@aira/shared';
import type { CSSProperties } from 'react';

/** Pill height as a share of the wordmark font size (design: max 80%). */
const PILL_HEIGHT_RATIO = 0.8;

/**
 * Status pill shown beside the AIRA wordmark.
 * Font is inherited so Admin keeps IBM Plex Sans and Outlook keeps Segoe UI.
 * Size follows `wordmarkPx` (the wordmark's font size) so the pill stays at
 * most 80% of its height. Colours and radius default to the shared tokens;
 * surfaces with their own theme (e.g. Admin's sidebar variables) override them
 * through `style`.
 */
export function BetaLabel({
  wordmarkPx = 16,
  style,
}: {
  wordmarkPx?: number;
  style?: CSSProperties;
}) {
  const height = Math.floor(wordmarkPx * PILL_HEIGHT_RATIO);
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        height,
        borderRadius: 4,
        backgroundColor: BETA_PILL_BG_HEX,
        color: BETA_PILL_FG_HEX,
        fontFamily: 'inherit',
        fontSize: Math.round(height * 0.8),
        fontWeight: 600,
        letterSpacing: '0.02em',
        lineHeight: 1,
        padding: '0 5px',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {BETA_LABEL}
    </span>
  );
}
